'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002420 from "./presto.-Dashboard-View$$anon$20.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dUser$002dStats$0024 from "./presto.types$-Dashboard-User-Stats$.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dUser$002dId$0024 from "./presto.types$-User-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$19() {
  this.aKZ = null;
  this.aKR = null;
  this.aKS = false;
  this.aL0 = null;
  this.aL1 = false;
  this.aL4 = null;
  this.aKX = null;
  this.aKY = false;
  this.aKT = null;
  this.aKU = false;
  this.aKV = null;
  this.aKW = false;
  this.aL2 = false;
  this.aL3 = false;
  this.aKZ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aL4 = "DashboardUserStats";
}
export { $c_Lpresto_DashboardView$$anon$19 as $c_Lpresto_DashboardView$$anon$19 };
$p = $c_Lpresto_DashboardView$$anon$19.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$19;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$19() {
}
export { $h_Lpresto_DashboardView$$anon$19 as $h_Lpresto_DashboardView$$anon$19 };
$h_Lpresto_DashboardView$$anon$19.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.aKZ;
});
$p.M = (function() {
  if ((!this.aKS)) {
    this.aKR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aKS = true;
  }
  return this.aKR;
});
$p.O = (function() {
  if ((!this.aL1)) {
    this.aL0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aL1 = true;
  }
  return this.aL0;
});
$p.D = (function() {
  return this.aL4;
});
$p.t = (function() {
  if ((!this.aKY)) {
    this.aKX = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("user", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("total", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aKY = true;
  }
  return this.aKX;
});
$p.N = (function() {
  if ((!this.aKU)) {
    this.aKT = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dUser$002dId$0024.$m_Lpresto_types$UserId$().k2(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().cJ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bC, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aKU = true;
  }
  return this.aKT;
});
$p.Q = (function() {
  if ((!this.aKW)) {
    this.aKV = new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002420.$c_Lpresto_DashboardView$$anon$20();
    this.aKW = true;
  }
  return this.aKV;
});
$p.v = (function() {
  if ((!this.aL3)) {
    this.aL2 = false;
    this.aL3 = true;
  }
  return this.aL2;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee95) => ((p) => \u03b4scrutinee95.cHu(p)))($j_presto$002etypes$0024$002dDashboard$002dUser$002dStats$0024.$m_Lpresto_types$DashboardUserStats$())));
});
var $d_Lpresto_DashboardView$$anon$19 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$19, "presto.DashboardView$$anon$19", ({
  GT: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_DashboardView$$anon$19 as $d_Lpresto_DashboardView$$anon$19 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$19.js.map
